/** Format pick-n package sub-lines for receipts and invoices. */
export function selectedServiceLabel(sel, lang = "ar") {
  if (!sel) return "";
  if (lang === "ar") return sel.name_ar || sel.name || sel.name_en || sel.service_id || "";
  return sel.name_en || sel.name || sel.name_ar || sel.service_id || "";
}

export function renderSelectedServicesHtml(items, lang, { indent = true } = {}) {
  return (items || []).map((it) => {
    const subs = it.selected_services || [];
    if (!subs.length) return "";
    const pad = indent ? "padding-inline-start:12px;font-size:10px;color:#666;" : "";
    return subs.map((sel) => {
      const name = selectedServiceLabel(sel, lang);
      return `<div style="${pad}">• ${escapeHtml(name)}</div>`;
    }).join("");
  }).join("");
}

function escapeHtml(s) {
  return String(s || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

export function invoiceItemRowsWithPackageSubs(items, lang, renderRow) {
  const out = [];
  (items || []).forEach((it, idx) => {
    out.push(renderRow(it, idx));
    (it.selected_services || []).forEach((sel) => {
      out.push(renderRow({
        ...it,
        name: `  • ${selectedServiceLabel(sel, lang)}`,
        qty: 1,
        unit_price: 0,
        line_total: 0,
        _isPackageSub: true,
      }, idx));
    });
  });
  return out.join("");
}
